module.exports = __webpack_public_path__ + "static/img/case_detail_01_1.c0568b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_01_1.png
// module id = Kcbu
// module chunks = 34